import { Link } from "react-router-dom";
import Accordion from "@/components/base/Accordion";
import Reveal from "@/components/base/Reveal";
import { faqs } from "@/mocks/faqs";

export default function FaqPreview() {
  return (
    <section className="bg-background-100" aria-labelledby="faq-preview-title">
      <div className="mx-auto grid w-full grid-cols-1 gap-10 px-4 py-16 md:px-6 md:py-20 lg:grid-cols-[minmax(0,0.8fr)_minmax(0,1.2fr)]">
        <Reveal>
          <div className="lg:sticky lg:top-28">
            <span className="inline-flex items-center gap-1.5 rounded-full bg-primary-100 px-3 py-1 font-label text-xs text-primary-700">
              <i className="ri-question-line" aria-hidden="true"></i>
              常见问题
            </span>
            <h2 id="faq-preview-title" className="mt-4 text-2xl leading-snug text-foreground-950 md:text-4xl">
              关于 513吃瓜，
              <br />
              你可能想问这些
            </h2>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">
              更新频率、投稿方式、内容原则，都在这里说清楚了。没找到答案的话，直接来问我们。
            </p>
            <Link
              to="/faq"
              className="mt-6 inline-flex items-center gap-1.5 whitespace-nowrap rounded-md border border-background-300 px-5 py-3 font-label text-sm text-foreground-800 transition-colors hover:border-primary-400 hover:text-primary-700"
            >
              查看全部问题
              <i className="ri-arrow-right-line" aria-hidden="true"></i>
            </Link>
          </div>
        </Reveal>

        <Reveal delay={100}>
          <Accordion items={faqs.slice(0, 5)} defaultOpen={0} />
        </Reveal>
      </div>
    </section>
  );
}